module.exports = __webpack_public_path__ + "media/images/pages/about/enfield-primary-d003706d175d73bd4d20872cbefe66cb.jpg";